import type { AdminUserListItem } from '@repo/sdk/gen'
import { makeBreadcrumbFromCache } from '@repo/ui/components/query-breadcrumbs'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import i18n from '@/lib/i18n'
import { makeQueryKeys } from '@/query/query-keys'
import { UserDetailPage } from './-components/user-detail-page'

const searchSchema = z.object({
	sessionsPage: z.number().int().min(1).catch(1).default(1)
})

export const Route = createFileRoute('/(private)/users/$userId/')({
	validateSearch: searchSchema,
	staticData: {
		breadcrumb: ({ params, queryClient }) =>
			makeBreadcrumbFromCache<AdminUserListItem | null>(
				queryClient,
				makeQueryKeys.users.detail(params.userId),
				(user) =>
					user?.name ||
					user?.email ||
					i18n.t('admin-users:detail.breadcrumb')
			)
	},
	component: AdminUserDetail
})

function AdminUserDetail() {
	const { userId } = Route.useParams()
	return <UserDetailPage userId={userId} />
}
